import { render, staticRenderFns } from "./OrderSummaryBand.vue?vue&type=template&id=6919f12e"
import script from "./OrderSummaryBand.vue?vue&type=script&lang=js"
export * from "./OrderSummaryBand.vue?vue&type=script&lang=js"
import style0 from "./OrderSummaryBand.vue?vue&type=style&index=0&id=6919f12e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports